export const urlMapping = {
    'contactar-con-ventas': 'ventas'
}